// src/components/vault/ui/VaultSkeleton.tsx
import { Card, CardContent } from '../../ui/card';
import { Skeleton } from '../../ui/skeleton';

export function VaultSkeleton() {
  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6">
      {/* Header skeleton */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between mb-4">
            <div className="space-y-2">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-4 w-32" />
            </div>
            <div className="text-right space-y-2">
              <Skeleton className="h-8 w-16 ml-auto" />
              <Skeleton className="h-4 w-24 ml-auto" />
            </div>
          </div>
          <Skeleton className="h-2 w-full" />
        </CardContent>
      </Card>

      {/* Tabs skeleton */}
      <div className="flex gap-2">
        <Skeleton className="h-10 w-32 rounded-lg" />
        <Skeleton className="h-10 w-32 rounded-lg" />
        <Skeleton className="h-10 w-32 rounded-lg" />
      </div>

      {/* Requirements skeleton */}
      <div className="space-y-3">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i}>
            <CardContent className="py-4">
              <div className="flex items-center justify-between">
                <Skeleton className="h-5 w-48" />
                <Skeleton className="h-6 w-24 rounded-full" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
